import { TripEventDto } from "../../proxy/integrations/seedling-supply-service/dto";
import { TripJourney } from "./trip-journey";

export class TripEvent {
    id: string;
    eventTypeId?: string;
    tripId?: string;
    eventDate?: string;
    journey?: TripJourney;
    eventTypeName?: string;
    creationDate?: string;
    receiverId?: string;
    receiverName?: string;
    comments?: string;
    journeyId?: string;

    constructor(dto: TripEventDto) {
        const { journey, ...rest } = dto;
        Object.assign(this, rest);
        this.journey = journey ? new TripJourney(journey) : undefined;
    }
}